import { render, staticRenderFns } from "./SearchIARelatedDocumentsComponent.vue?vue&type=template&id=a8a44422&scoped=true"
import script from "./SearchIARelatedDocumentsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchIARelatedDocumentsComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchIARelatedDocumentsComponent.vue?vue&type=style&index=0&id=a8a44422&lang=scss&scoped=true"
import style1 from "./SearchIARelatedDocumentsComponent.vue?vue&type=style&index=1&id=a8a44422&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a44422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8a44422')) {
      api.createRecord('a8a44422', component.options)
    } else {
      api.reload('a8a44422', component.options)
    }
    module.hot.accept("./SearchIARelatedDocumentsComponent.vue?vue&type=template&id=a8a44422&scoped=true", function () {
      api.rerender('a8a44422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIARelatedDocumentsComponent.vue"
export default component.exports